"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _travelHeading = _interopRequireDefault(require("../travel-heading"));

var _block = _interopRequireDefault(require("./block"));

var _cars = _interopRequireDefault(require("./images/cars.png"));

var _financing = _interopRequireDefault(require("./images/financing.png"));

var _payments = _interopRequireDefault(require("./images/payments.png"));

var _insurance = _interopRequireDefault(require("./images/insurance.png"));

var _hotels = _interopRequireDefault(require("./images/hotels.png"));

var _flights = _interopRequireDefault(require("./images/flights.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TravelServices = function TravelServices(props) {
  var TRAVEL_SERICES_URLS = props.TRAVEL_SERICES_URLS;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "services index-section",
    id: "our-service"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react["default"].createElement(_travelHeading["default"], {
    heading: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Our Services")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "services__list"
  }, /*#__PURE__*/_react["default"].createElement(_block["default"], {
    img: _flights["default"],
    url: TRAVEL_SERICES_URLS.flights,
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Flights"),
    detail: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Find the lowest fares, browse seating classes, and compare rates from worldwide")
  }), /*#__PURE__*/_react["default"].createElement(_block["default"], {
    img: _hotels["default"],
    url: TRAVEL_SERICES_URLS.hotels,
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Hotels"),
    detail: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Choose from millions of hotels worldwide. Book now, pay later")
  }), /*#__PURE__*/_react["default"].createElement(_block["default"], {
    img: _cars["default"],
    url: TRAVEL_SERICES_URLS.cars,
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Cars"),
    detail: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Browse short and long-term rentals from the most trusted names")
  }), /*#__PURE__*/_react["default"].createElement(_block["default"], {
    img: _insurance["default"],
    url: TRAVEL_SERICES_URLS.insurance,
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Insurance"),
    detail: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Protect your trip from delays, cancellations, and more with AIG\u2019S Travel Guard")
  }), /*#__PURE__*/_react["default"].createElement(_block["default"], {
    img: _payments["default"],
    url: TRAVEL_SERICES_URLS.payments,
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Payments"),
    detail: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Send and receive money faster with Zelle")
  }), /*#__PURE__*/_react["default"].createElement(_block["default"], {
    url: TRAVEL_SERICES_URLS.financing,
    img: _financing["default"],
    title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Financing"),
    detail: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Book now, pay later")
  }))));
};

var _default = TravelServices;
exports["default"] = _default;